module.exports = __webpack_public_path__ + "media/logos/EscudoNLH-ece14ff7.png";